<template>
  <div>
    <div class="flex flex-col mx-auto page-container lg:gap-2 boundary py-3 overflow-x-hidden max-w-full">
      <div class="pb-4">
        <BreadCrumbs v-if="path" :path="path" />
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import BreadCrumbs from "./BreadCrumbs.vue";

defineProps(["path"]);
</script>
